module.exports = __webpack_public_path__ + "static/images/jf-bg-icon.d369785.png";